

(function () {
  function addParentClass(parentSelector) {
    const added = `parent-${parentSelector.replace('.', '')}`;

    const run = parent => {
      // parent.querySelectorAll(':scope > *').forEach(child => {
          parent.querySelectorAll(':scope > *').forEach(child => {
        child.classList.add(added);
      });
    };

    const init = () => {
      document.querySelectorAll(parentSelector).forEach(parent => {
        run(parent);

        new MutationObserver(() => run(parent))
          .observe(parent, { childList: true });
      });
    };

    new MutationObserver(init)
      .observe(document.body, { childList: true, subtree: true });

    init();
  }

  // 🔥 USE HERE (ADD MORE PARENT CLASSES)
 // addParentClass('.filter-shape-item');
 //  addParentClass('.diamond-proxy-shape-filter');
  // addParentClass('.diamond-proxy-colour-filter');
  // addParentClass('.parent-diamond-proxy-colour-filter');
 //  addParentClass('.custom-intensity-filter');
//   addParentClass('.parent-custom-intensity-filter');
//  addParentClass('.parent-parent-custom-intensity-filter');
 //  addParentClass('.parent-diamond-proxy-shape-filter');
 //   addParentClass('.diamond-proxy-filter-parent-container');
  // addParentClass('.parent-diamond-proxy-filter-parent-container');
 // addParentClass('.parent-parent-diamond-proxy-filter-parent-container');
   // addParentClass('.diamond-proxy-product-details');
    //  addParentClass('.parent-diamond-proxy-product-details');
    //  addParentClass('.has-active-filter');
   //   addParentClass('.parent-has-active-filter');
    //    addParentClass('.parent-parent-has-active-filter');
   //   addParentClass('.color-header');
   //   addParentClass('.custome-color-list');
   //    addParentClass('.view-details-wrapper');
   //  addParentClass('.parent-view-details-wrapper');

   

   



   
  // addParentClass('.another-parent-class');
})();







// second div

(function () {

  function addClassToSecondDivInsideParent(config) {
    const { parentSelector, classToAdd } = config;

    document.querySelectorAll(parentSelector).forEach(parent => {
      const children = parent.children;
      if (children.length <= 2) {
        children[0].classList.add(classToAdd);
      }
    }); 
  }

  function initSecondDivClass() {
    addClassToSecondDivInsideParent({
      parentSelector: '.custome-color-list',
      classToAdd: 'unique-color-list'
    });
  }

  // run once
  initSecondDivClass();

  // dynamic / Shopify safe
  new MutationObserver(initSecondDivClass).observe(document.body, {
    childList: true,
    subtree: true
  });

})();

